import { registerView, View, ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import * as React from "react";
import { Col, Form, Row } from "react-bootstrap";
import MethodOfSignature from "views/notice/components/methodOfSignature";
import Toolbox from "../components/toolbox";
import LoadingModal from "../../common/loadingModal/loadingModal";
import ErrorCard from "../../common/error/errorCard";
import LicensePlateChangeViewModel from "../../../viewModels/notice/licensePlateChange/licensePlateChangeViewModel";
import LicensePlateChangeNotice from "./notice";
import DocumentUploader from "../components/documentUploader";
import { Alert } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import LoadingPane from "../../../controls/loadingPane";

const LicensePlateChangeView: ViewComponent<LicensePlateChangeViewModel> = observer(({ vm }) => {
  const translate = (value: string) => vm.localizationService.translateGeneral(`licensePlateChange.${value}`);
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  return (
    <>
      <View vm={vm.outagesViewModel} />
      <div className="bg-white p-3 p-lg-4 p-xl-7 rounded">
        <Form className="p-3 p-lg-4 p-xl-7" ref={formRef}>
          <ErrorCard message={vm.errorMessage} sticky={true} />
          <LicensePlateChangeNotice vm={vm} />
          {vm.loadingData && !vm.vehicleChargingInstructions && (
            <Row className="d-flex justify-content-center align-items-center pb-3 pb-lg- pb-xl-3">
              <Col sm={1} lg="auto" className="p-2 spinner-auto">
                <LoadingPane />
              </Col>
              <Col sm={4} lg="auto" className="p-2">
                <div className="d-flex justify-content-center align-items-center">{translate("loadingInstruction")}</div>
              </Col>
            </Row>
          )}
          {vm.vehicleChargingInstructions &&
            vm.vehicleChargingInstructions.warningReasons?.map(instruction => (
              <Alert key={instruction} variant="warning">
                <strong className="font-size-sm">
                  {vm.translateWarningReason(instruction, vm.vehicleChargingInstructions?.possibleExemptionReasonIds)}
                </strong>
              </Alert>
            ))}
          <View vm={vm.applicantPersonViewModel} />
          <MethodOfSignature vm={vm} />
          <DocumentUploader vm={vm} translateKey={"licensePlateChange"} />
          {vm.vehicleChangeApplicationProduction &&
            !vm.vehicleChangeApplicationProduction?.rejectionReason &&
            vm.vehicleChangeApplicationProduction.warningReasons?.map(instruction => (
              <Alert key={instruction} variant="warning">
                <ReactMarkdown linkTarget="_blank">{vm.translateWarningReason(instruction)}</ReactMarkdown>
              </Alert>
            ))}
          {vm.vehicleChangeApplicationProduction?.rejectionReason && (
            <Alert key={vm.vehicleChangeApplicationProduction.rejectionReason} variant="danger">
              <strong className="font-size-sm">
                {vm.translateWarningReason(vm.vehicleChangeApplicationProduction.rejectionReason)}
              </strong>
            </Alert>
          )}
          <Toolbox vm={vm} />
          <LoadingModal translate={vm.translateGeneral} isVisible={vm.showLoadingModal} />
        </Form>
      </div>
    </>
  );
});

registerView(LicensePlateChangeView, LicensePlateChangeViewModel);
